import { render, staticRenderFns } from "./ChainBase.vue?vue&type=template&id=5b63e4c6&"
import script from "./ChainBase.vue?vue&type=script&lang=js&"
export * from "./ChainBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports